var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h100"},[_vm._m(0),_c('v-footer',{staticClass:"footer-fix"})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-404 shadow"},[_c('a',{attrs:{"href":"/home.html"}},[_vm._v("返回首页")])])
}]

export { render, staticRenderFns }